import BaseNormalizer from "./BaseNormalizer";

const imageAttachmentNormalizer = Object.create(BaseNormalizer).init([
  "id",
  "filename",
  "mimeType",
  "orderIndex",
  "thumbnailSizeUri",
  "mediumSizeUri",
  "highSizeUri",
  "originalSizeUri",
]);

export default imageAttachmentNormalizer;
